// src/contexts/HelpContext.jsx
// Manages the help slide-over panel state so any HelpLink in the tree can trigger it.

import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const HelpContext = createContext();

export const HelpProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentArticle, setCurrentArticle] = useState(null);

  const openArticle = useCallback((article) => {
    setCurrentArticle(article);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    // Delay clearing article so the slide-out animation can finish
    setTimeout(() => setCurrentArticle(null), 300);
  }, []);

  const value = useMemo(() => ({
    isOpen,
    currentArticle,
    openArticle,
    close,
  }), [isOpen, currentArticle, openArticle, close]);

  return (
    <HelpContext.Provider value={value}>
      {children}
    </HelpContext.Provider>
  );
};

export const useHelpPanel = () => {
  const context = useContext(HelpContext);
  if (context === undefined) {
    throw new Error('useHelpPanel must be used within a HelpProvider');
  }
  return context;
};
